import React from 'react';
import { View } from './Themed';
import { StyleSheet } from 'react-native';

const Container = (props: any) => {
    return <View style={styles.container} {...props} />
}

const styles = StyleSheet.create({
    container: {
      flex: 1,
      alignItems: 'center',
      justifyContent: 'center',
    }
});

export default Container
